import { resolveApiBase } from '@cadenza/io-utils';
import { requestJson } from './http.js';

const resolveBase = () => resolveApiBase('/api');

const jsonRequest = (path, { base = resolveBase(), ...rest } = {}) =>
  requestJson(base, path, rest);

const getSession = (config) => jsonRequest('/auth/session', { ...config, method: 'GET' });

const signup = (config = {}, data) =>
  jsonRequest('/auth/signup', {
    ...config,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ?? {}),
  });

const login = (config = {}, data) =>
  jsonRequest('/auth/login', {
    ...config,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ?? {}),
  });

const logout = (config = {}) =>
  jsonRequest('/auth/logout', {
    ...config,
    method: 'POST',
  });

export { getSession, login, logout, signup };
